import WaveSurfer from "wavesurfer.js";
import { create } from "zustand";

type State = {
  audioPlaying: HTMLAudioElement | WaveSurfer | AudioContext | null;
  setAudioPlaying: (
    audio: HTMLAudioElement | WaveSurfer | AudioContext | null
  ) => void;
  pauseAudio: () => void;
  setAudioPlayingToZero: () => void;
};

export const useAudioPlaying = create<State>()((set) => ({
  audioPlaying: null,
  setAudioPlaying: (audio) => {
    set({ audioPlaying: audio });
  },
  pauseAudio: () =>
    set((state) => {
      if (state.audioPlaying !== null) {
        if (state.audioPlaying instanceof HTMLAudioElement) {
          state.audioPlaying.pause();
        } else if (state.audioPlaying instanceof AudioContext) {
          // Can't really be done centrally
        } else {
          state.audioPlaying.pause();
        }
      }

      return state;
    }),
  setAudioPlayingToZero: () =>
    set((state) => {
      if (state.audioPlaying !== null) {
        if (state.audioPlaying instanceof HTMLAudioElement) {
          state.audioPlaying.currentTime = 0;
        } else if (state.audioPlaying instanceof AudioContext) {
          // Can't really be done centrally
        } else {
          state.audioPlaying.seekTo(0);
          state.audioPlaying.options.interact = false;
        }
      }

      return state;
    }),
}));
